import React from 'react'
import { Link } from 'react-router-dom'

import CoordRotas from './CoordRotas'

export default class Rotas extends React.Component {
    constructor(props) {
        super(props)
        this.state = { fiscal: localStorage.nome, tipo: localStorage.tipo }
    }

    render() {
        if (this.state.tipo == 'fiscal' || this.state.tipo == 'fiscalAssessor') { 
            return (
                <div className="container">
                    <Link to='/novaRota'>
                        <div className="ficha pacientes col-md-12 col-lg-4 d-inline-block">
                            <i class="fas fa-map-marked-alt verdeUnimed icone"></i>
                            <b className="verdeUnimed">NOVA ROTA</b>
                        </div>
                    </Link>

                    <Link to='/minhasRotas'>
                        <div className="ficha pacientes col-md-12 col-lg-4 d-inline-block">
                            <i class="fas fa-map-signs verdeUnimed icone"></i>
                            <b className="verdeUnimed">MINHAS ROTAS</b>
                        </div>
                    </Link>

                    <Link to='/rotas'>
                        <div className="ficha pacientes col-md-12 col-lg-4 d-inline-block">
                            <i class="fas fa-file-alt cinza icone"></i>
                            <b className="cinza">RELATÓRIO DE ROTAS</b>
                        </div>
                    </Link>
                </div>
            )
        }
        else if (this.state.tipo == 'coordenacao' || this.state.tipo == 'presidencia' || this.state.tipo == 'interno'
            || this.state.tipo == 'vice-presidencia' || this.state.tipo == 'defis') {
            return (
                <div className="container">
                    <Link to='/coordRotas'>
                        <div className="ficha pacientes col-md-12 col-lg-4 d-inline-block">
                            <i class="fas fa-map-signs verdeUnimed icone"></i>
                            <b className="verdeUnimed">ROTAS</b>
                        </div>
                    </Link>

                    <Link to='/novaRota'>
                        <div className="ficha pacientes col-md-12 col-lg-4 d-inline-block">
                            <i class="fas fa-map-marked-alt verdeUnimed icone"></i>
                            <b className="verdeUnimed">NOVA ROTA</b>
                        </div>
                    </Link>

                    <Link to='/rotasCoord'>
                        <div className="ficha pacientes col-md-12 col-lg-4 d-inline-block">
                            <i class="fas fa-file-alt verdeUnimed icone"></i>
                            <b className="verdeUnimed">RELATÓRIOS DE ROTAS</b>
                        </div>
                    </Link>
                </div>
            )
        }
    }
}